import { FilterParams } from 'interfaces/filters';
import { PaginationParams } from 'interfaces/pagination';
import { IAiUser } from 'interfaces/settings/AiUser/AiUser';
import { IResponseGetAiUsers } from 'interfaces/settings/AiUser/ResponseGetAiUsers';
import { applyQueryString } from 'lib/queryString';
import { apiGeneral } from 'services';

export function useAiUser() {
  const getAiUsers = async (
    filters: FilterParams,
    pagination: PaginationParams
  ): Promise<any> => {
    const url = applyQueryString(`/ai-users`, {
      ...filters,
      ...pagination,
    });
    const { data } = await apiGeneral.get<IResponseGetAiUsers>(url);
    return data;
  };

  const createAiUser = async (data: Partial<IAiUser>): Promise<void> => {
    await apiGeneral.post('/ai-users', data);
  };

  const updateAiUser = async (data: Partial<IAiUser>): Promise<void> => {
    await apiGeneral.put(`/ai-users/${data.id}`, data);
  };

  const deleteAiUser = async (id: number): Promise<void> => {
    await apiGeneral.delete(`/ai-users/${id}`);
  };

  const getAiUser = async (id: string): Promise<IAiUser> => {
    const { data } = await apiGeneral.get<IAiUser>(`/ai-users/${id}`);
    return data;
  };

  return { getAiUsers, getAiUser, createAiUser, updateAiUser, deleteAiUser };
}
